import type { FaireProductEntity } from "../../entity_types/product";

export const p_hnduanmzbv: FaireProductEntity = {
  token: "p_hnduanmzbv",
  type: "product",
  name: "Taken Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/b9c403a0df3f0eb7820a2358812f7d0362367e63fe1f4f733d9fc3b170faeac4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1d870e6b4b2cd5c5667c9e77533eccc92a5e94b50ea12ffec7d1525fb55a89d.jpeg",
    "https://cdn.faire.com/fastly/e4217a3b650901267fbaeda8bd4acaa17774aedde6c6d9255aed11f866631c9f.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/01d595ad2c73c6240542afdd515bd1dd0cc6aa10e1cf0f8288a025916e1c6998.jpeg",
    "https://cdn.faire.com/fastly/d4cc880df7f0299ed1a0d978aff04c553640d577704b77d3fa2dd29b3ccc1991.jpeg",
    "https://cdn.faire.com/fastly/d5445a682f7ba03602178d6c05545be368b4a42e79d65a33d4dc6af394752f97.jpeg",
    "https://cdn.faire.com/fastly/4ec1257195ef61b4868bb947da2805f40ecce8c2e86bbfbc6d711079c06673d3.jpeg",
    "https://cdn.faire.com/fastly/c1af3725bbe683b11893ce40a5747d3e83f8799996ff1ae0f5c4cea4fd2479d2.jpeg"
  ],
  priceDollars: 3.38,
  description: "Limited Availability - Will Not Restock\n\nThese socks are great if you're in a committed relationship or also if you're just a big Liam Neeson fan. 😊\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:21.060Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
